//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/DisplayableObject.js";
import "../no/ugmath.js";
let d=[[],[[[],"GetParentTable",{R_:{tabnot:"Annotations.Annotation"}},0,0],[["isMergedCell"],"GetUpperLeft",{R_:{point:''}},1,0],[["isMergedCell","upperLeftPoint","bottomLeftPoint","bottomRightPoint","upperRightPoint"],"GetCorners",{},1,0],[["isMergedCell","cellWidth","cellHeight"],"GetCellSize",{},1,0],[[],"GetRow",{R_:{row:"Annotations.TableRow"}},0,0],[[],"GetColumn",{R_:{column:"Annotations.TableColumn"}},0,0],[[],"GetSection",{R_:{section:"Annotations.TableSection"}},0,0]],[]];
SPLM.Annotations.TableCell = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.TableCell";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;